import { ReactNode } from 'react';
import { t } from '@ankr.com/common';
import { Chain } from '@ankr.com/chains-list';

import { UpgradeAccountDialog } from 'modules/common/components/UpgradeAccountDialog';
import { chainsRoutesConfig } from 'domains/chains/routes';
import { useDialog } from 'modules/common/hooks/useDialog';
import { useSignInWithRedirectURL } from 'modules/auth/hooks/useSignInWithRedirectURL';

import { EndpointPlaceholder } from '../../../EndpointPlaceholder';

export interface PlaceholderProps {
  title: ReactNode;
  publicChain: Chain;
  shouldSignIn?: boolean;
}

export const Placeholder = ({
  publicChain,
  shouldSignIn,
  title,
}: PlaceholderProps) => {
  const {
    isOpened: isPromoDialogOpened,
    onClose: onPromoDialogClose,
    onOpen: onPromoDialogOpen,
  } = useDialog();

  const signIn = useSignInWithRedirectURL({
    hasAPIKeysNotification: true,
    redirectURL: chainsRoutesConfig.chainDetails.generatePath(publicChain.id),
  });

  return (
    <>
      <EndpointPlaceholder
        title={title}
        onClick={shouldSignIn ? signIn : onPromoDialogOpen}
        lockedLabel={t('chain-item.get-started.endpoints.lockedLabelHttps')}
      />
      <UpgradeAccountDialog
        isOpened={isPromoDialogOpened}
        onClose={onPromoDialogClose}
      />
    </>
  );
};
